import * as React from 'react';

import { useQuery } from '@apollo/client';

import { useParams } from 'js/lib/useRouter';

import DegreeDescriptionPageAdmissionDeadlinesContext from 'bundles/degree-description/contexts/DegreeDescriptionPageAdmissionDeadlinesContext';
import type {
  GetProgramAdmissionDeadlinesBySlug_Dedupe1Query,
  GetProgramAdmissionDeadlinesBySlug_Dedupe1QueryVariables,
} from 'bundles/degree-description/queries/__generated__/getProgramAdmissionDeadlinesBySlug';
import getProgramAdmissionDeadlinesBySlug from 'bundles/degree-description/queries/getProgramAdmissionDeadlinesBySlug.graphql';

// https://coursera.atlassian.net/browse/DEGCON-913 (For specific slugs that have redirects, we are hardcoding the required slug and passing to the API)
const transformSlug = (slug: string): string => {
  if (slug === 'master-of-computer-science-illinois') {
    return 'masters-in-computer-data-science';
  }
  return slug;
};

export const DegreeDescriptionPageAdmissionDeadlinesProvider: React.LegacyFunctionComponentWithChildren = ({
  children,
}) => {
  const { slug } = useParams();
  const degreeSlug = transformSlug(slug);

  const { data } = useQuery<
    GetProgramAdmissionDeadlinesBySlug_Dedupe1Query,
    GetProgramAdmissionDeadlinesBySlug_Dedupe1QueryVariables
  >(getProgramAdmissionDeadlinesBySlug, {
    skip: !degreeSlug,
    variables: {
      degreeSlug,
    },
    context: { clientName: 'gatewayGql' },
  });

  const queryData = {
    programAdmissionDeadlinesData: data?.DegreeDescriptionPageModules?.queryProgramAdmissionDeadlines || [],
  };

  return (
    <DegreeDescriptionPageAdmissionDeadlinesContext.Provider value={queryData}>
      {children}
    </DegreeDescriptionPageAdmissionDeadlinesContext.Provider>
  );
};
